<h2 mat-dialog-title>Notification Delivery Options</h2>
<mat-progress-bar
    *ngIf="isLoading || isSaving"
    mode="indeterminate"
    aria-label="options progress"
></mat-progress-bar>
<mat-dialog-content
    *ngIf="!isLoading"
    id="notification-options"
    aria-label="notification options"
>
    <form [formGroup]="settingsForm">
        <mat-radio-group class="options" [formControl]="notification">
            <mat-radio-button value="{{ Option.Immediately }}"
                >Send notification immediately</mat-radio-button
            >
            <mat-radio-button value="{{ Option.Summary }}"
                >Send a daily summary of notifications</mat-radio-button
            >
        </mat-radio-group>
        <div
            class="time"
            *ngIf="notification.value === Option.Summary"
            [formGroup]="time"
        >
            <mat-form-field class="time-part">
                <mat-label>Hour</mat-label>
                <mat-select formControlName="{{ Control.Hours }}">
                    <mat-option *ngFor="let i of hoursOptions" [value]="i">{{
                        i
                    }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="time-part">
                <mat-label>Minute</mat-label>
                <mat-select formControlName="{{ Control.Minutes }}">
                    <mat-option *ngFor="let i of minutesOptions" [value]="i">{{
                        i
                    }}</mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="time-part">
                <mat-label>AM/PM</mat-label>
                <mat-select formControlName="{{ Control.Meridiem }}">
                    <mat-option [value]="Meridiem.Am">{{
                        Meridiem.Am
                    }}</mat-option>
                    <mat-option [value]="Meridiem.Pm">{{
                        Meridiem.Pm
                    }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button color="primary" (click)="saveSettings()">Save</button>
    <button mat-button matDialogClose>Cancel</button>
</mat-dialog-actions>
